export default context => {
    $('[data-action="copy-url"]', context).on('click', function() {
        navigator.clipboard.writeText($(this).attr('href'));
        return false
    })
}
